export default __webpack_public_path__ + "static/media/failed.4ac8bbcb.svg";